import React from 'react';
import { Box } from '@mui/material';

/* eslint-disable react/prop-types */

const Container: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box
      width={{
        xs: '90%',
        lg: '1132px',
      }}
      display="flex"
      flexDirection="row"
      mx="auto"
    >
      {children}
    </Box>
  );
};

export default Container;
